import React, { useEffect, useState } from 'react'
import {
  Button,
  Card,
  Form,
  Row,
  Col,
  Typography,
  message,
  Select,
  Tooltip,
} from 'antd'
import { REGEXS, formatAmount } from 'utils'
import { useEventSelector } from 'store/eventSlice/eventReducer'
import { useAuthSelector } from 'store/authSlice/authReducer'
import { addCashDonation } from 'store/paymentSlice/paymentActions'
import * as Yup from 'yup'
import Api from 'api'
import { MdPersonAddAlt } from 'react-icons/md'
import { AddCommunityMemberModal } from 'components/common'
import { AmountInput } from 'components/elements'

const { Title } = Typography

const amountValidation = REGEXS.amountRegex
const schema = Yup.object().shape({
  askedAmount: Yup.string()
    .required('Required')
    .matches(amountValidation, 'Invalid amount'),
  communityMember: Yup.string().required('Select a community member'),
  type: Yup.string().required('Type is required'),
})

const addCollectedAmountValidation = {
  async validator({ field }, value) {
    await schema.validateSyncAt(field, { [field]: value })
  },
}

const initialValues = {}

const RegisterCashDonation = () => {
  const [form] = Form.useForm()
  const [community, setCommunity] = useState([])
  const [loading, setLoading] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const { event } = useEventSelector()
  const { organization } = useAuthSelector()

  Form.useWatch('askedAmount', form)

  const getDonors = () => {
    Api.get(`subscriber/donorList/${organization.id}`)
      .then((res) => {
        const filterMembers = res?.result?.filter(
          (item) => item.DonorEmail && item.DonorPhoneNumber,
        )
        setCommunity(filterMembers)
      })
      .catch((error) => {
        console.log('error', error)
      })
  }

  useEffect(() => {
    getDonors()
    // eslint-disable-next-line
  }, [])

  const onFinish = async (values) => {
    setLoading(true)
    const memeber = community.find(
      (item) => item.Id === values?.communityMember,
    )
    try {
      const data = {}

      const askedAmountValue = Number(values.askedAmount.replaceAll(/,/g, ''))
      data.amount = askedAmountValue
      data.contributeToEventCost = false
      data.DonorEmail = memeber?.DonorEmail
      data.CreatedBy = memeber?.DonorEmail
      data.DonorPhoneNumber = memeber?.DonorPhoneNumber
      data.DonorName = memeber?.DonorName

      data.EventId = event.Id
      data.EventName = event.Title
      data.transactionType =
        event.EventType === 'Fundraiser' ? 'event' : 'campaign'

      data.DonorZipCode = organization?.ZipCode
      data.isAttendingOnline = false
      data.Table = null
      data.isDonatingAnonymously = false
      data.isManualEntry = true
      data.PaymentType = values.type

      await addCashDonation(data)

      form.resetFields()
      message.success('Cash Added Successfully')
      setLoading(false)
    } catch (error) {
      setLoading(false)
      message.error(error?.response?.data?.error || 'Something Went Wrong')
    }
  }

  const askedAmountValue = form.getFieldValue('askedAmount')

  const askedAmountWithoutComma = askedAmountValue?.replaceAll(/,/g, '')

  return (
    <Card className="t-w-full">
      <Form
        form={form}
        layout="vertical"
        key={0}
        onFinish={onFinish}
        name="organization"
        initialValues={initialValues}
        scrollToFirstError
      >
        <Row gutter={[24, 0]}>
          <Col span={24} className="t-flex t-justify-end t-items-center">
            <Tooltip title="Add New Community Member">
              <MdPersonAddAlt
                fontSize="1.5rem"
                className="t-text-secondary-100 t-cursor-pointer"
                onClick={() => setShowModal(true)}
              />
            </Tooltip>
          </Col>
          <Col span={24}>
            <Form.Item
              name="communityMember"
              label="Search Community Member (must have valid phone number and email)"
              colon={false}
              rules={[addCollectedAmountValidation]}
            >
              <Select
                style={{ width: '100%' }}
                showSearch
                optionFilterProp="children"
              >
                {community?.map((item, index) => (
                  <Select.Option value={item.Id} key={index}>
                    {item.DonorName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xl={24} md={24} xs={24} sm={24}>
            <Form.Item
              name="askedAmount"
              label="Amount"
              colon={false}
              rules={[addCollectedAmountValidation]}
            >
              <AmountInput
                placeholder="Add Collected Amount"
                onChange={(value) =>
                  form.setFieldsValue({
                    askedAmount: value,
                  })
                }
              />
            </Form.Item>
          </Col>
          <Col xl={24} md={24} xs={24} sm={24}>
            <Form.Item
              name="type"
              label="Type"
              colon={false}
              rules={[addCollectedAmountValidation]}
            >
              <Select placeholder="Type" style={{ width: '100%' }}>
                {['Cash', 'Cheque', 'Zelle'].map((item, index) => (
                  <Select.Option value={item} key={index}>
                    {item}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xl={24} md={24} xs={24} sm={24}>
            <Row justify="end">
              <Title level={3}>
                {`Total Donation = ${formatAmount(askedAmountWithoutComma)}`}
              </Title>
            </Row>
          </Col>
          <Col span={24} className="text-right">
            <Button
              loading={loading}
              type="primary"
              className="px-25"
              htmlType="submit"
            >
              {loading ? 'Registering ...' : 'Register'}
            </Button>
          </Col>
        </Row>
      </Form>
      <AddCommunityMemberModal
        isVisible={showModal}
        onClose={() => setShowModal(false)}
        getData={getDonors}
      />
    </Card>
  )
}

export { RegisterCashDonation }
